import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';

import Home from './components/Home/home';

// Every page except the home page loads on demand, so visitors to the home page
// don't download Firebase and the portal code they will never use.
const TravelJournal = lazy(() => import('./components/TravelJournal/travelJournal'));
const EvolvingWithBooks = lazy(() => import('./components/Books/evolvingWithBooks'));
const Recipe = lazy(() => import('./components/Recipe/recipe'));
const InvestingPlaybook = lazy(() => import('./components/Investing Playbook/investing_playbook'));
const Portal = lazy(() => import('./components/Portal/portal'));
const Weight = lazy(() => import('./components/Portal/weight'));
const Lifts = lazy(() => import('./components/Portal/lifts'));
const StartWorkout = lazy(() => import('./components/Portal/startWorkout'));
const LiftDay = lazy(() => import('./components/Portal/liftDay'));
const NotFoundPage = lazy(() => import('./components/404/404'));

function App() {
  return (
    <Router>
      <Suspense fallback={null}>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/travel" component={TravelJournal} />
          <Route exact path="/evolvingwithbooks" component={EvolvingWithBooks} />
          <Route exact path="/delizioso" component={Recipe} />
          <Route exact path="/investing_playbook" component={InvestingPlaybook} />
          <Route exact path="/megladonjourney" component={Portal} />
          <Route exact path="/megladonjourney/weight" component={Weight} />
          <Route exact path="/megladonjourney/lifts" component={Lifts} />
          <Route exact path="/megladonjourney/lifts/start" component={StartWorkout} />
          <Route exact path="/megladonjourney/lifts/:day" component={LiftDay} />
          <Route exact path="/404" component={NotFoundPage} />
          <Redirect to="/404" />
        </Switch>
      </Suspense>
    </Router>
  );
}

export default App;
